import React from "react";
import styles from "./index.module.scss";

export type Props = {};

const ShopNearMe: React.FC<Props> = (props) => {
  return <>health check is ok.</>;
};
export default ShopNearMe;
